import { useTranslation } from 'react-i18next';

import { useClosedWorkflowRewardingReportData } from '~/data/reports';
import { SavedReportSettingsType } from '~/data/reportSettings';

import { WorkflowReportBase } from '../../People/WorkflowReport/Common/WorkflowReportBase';
import { ClosedWorkflowRewardingReportConfig } from '../../People/WorkflowReport/types';

import { useClosedWorkflowRewardingReport } from './useClosedWorkflowReport';

export const ClosedWorkflowRewardingReport = () => {
  const { t } = useTranslation();

  const config: ClosedWorkflowRewardingReportConfig = {
    reportType: SavedReportSettingsType.ClosedWorkflowRewarding,
    dataFetchHook: useClosedWorkflowRewardingReportData,
    useReportHook: useClosedWorkflowRewardingReport,
    reportTitle: t('laClosedWorkflowsReport'),
    visibleToggles: ['showHistory'],
  };

  return (
    <WorkflowReportBase config={config} initialColumnVisibilityModel={{}} />
  );
};
